import { Outlet } from 'react-router-dom';

import Footer from '../components/common/Footer';
import Header from '../components/common/Header';

const PreAuthLayout: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
            <Header showSidebarToggle={false} />
            <main className="flex-1 w-full">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default PreAuthLayout;
